import type { LogRow } from '../api/client'

/** Stable identity shared by rendering, pagination and the live tail. */
export function logRowIdentity(row: LogRow): string {
  return row._tier1_id ?? `logs:${row.id}`
}

/** Keep the first occurrence of each stored row identity and add it to seen. */
export function dedupeLogRows(rows: LogRow[], seen: Set<string> = new Set()): LogRow[] {
  return rows.filter(row => {
    const identity = logRowIdentity(row)
    if (seen.has(identity)) return false
    seen.add(identity)
    return true
  })
}

/** Replace shown projections by identity; count only previously unseen rows. */
export function mergeTailRows(prev: LogRow[], rows: LogRow[]): { rows: LogRow[]; added: number } {
  const merged = [...prev]
  const positions = new Map(merged.map((row, index) => [logRowIdentity(row), index]))
  let added = 0
  for (const row of rows) {
    const identity = logRowIdentity(row)
    const index = positions.get(identity)
    if (index !== undefined) {
      merged[index] = row
    } else {
      positions.set(identity, merged.length)
      merged.push(row)
      added++
    }
  }
  return { rows: merged, added }
}
